/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import * as models from "../index.js";

export const GetApiV3MetricsAverageCycleBurnRateFormat = {
  Json: "json",
  Csv: "csv",
} as const;
export type GetApiV3MetricsAverageCycleBurnRateFormat = ClosedEnum<
  typeof GetApiV3MetricsAverageCycleBurnRateFormat
>;

export type GetApiV3MetricsAverageCycleBurnRateRequest = {
  format?: GetApiV3MetricsAverageCycleBurnRateFormat | undefined;
};

export type AverageCycleBurnRate = number | string;

/**
 * Average cycle burn rate over the last 90 day period
 */
export type GetApiV3MetricsAverageCycleBurnRateResponseBody = {
  averageCycleBurnRate?: Array<number | string> | undefined;
};

export type GetApiV3MetricsAverageCycleBurnRateResponse =
  | models.ErrorT
  | GetApiV3MetricsAverageCycleBurnRateResponseBody;

/** @internal */
export const GetApiV3MetricsAverageCycleBurnRateFormat$inboundSchema:
  z.ZodNativeEnum<typeof GetApiV3MetricsAverageCycleBurnRateFormat> = z
    .nativeEnum(GetApiV3MetricsAverageCycleBurnRateFormat);

/** @internal */
export const GetApiV3MetricsAverageCycleBurnRateFormat$outboundSchema:
  z.ZodNativeEnum<typeof GetApiV3MetricsAverageCycleBurnRateFormat> =
    GetApiV3MetricsAverageCycleBurnRateFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsAverageCycleBurnRateFormat$ {
  /** @deprecated use `GetApiV3MetricsAverageCycleBurnRateFormat$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3MetricsAverageCycleBurnRateFormat$inboundSchema;
  /** @deprecated use `GetApiV3MetricsAverageCycleBurnRateFormat$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3MetricsAverageCycleBurnRateFormat$outboundSchema;
}

/** @internal */
export const GetApiV3MetricsAverageCycleBurnRateRequest$inboundSchema:
  z.ZodType<GetApiV3MetricsAverageCycleBurnRateRequest, z.ZodTypeDef, unknown> =
    z.object({
      format: GetApiV3MetricsAverageCycleBurnRateFormat$inboundSchema.default(
        "json",
      ),
    });

/** @internal */
export type GetApiV3MetricsAverageCycleBurnRateRequest$Outbound = {
  format: string;
};

/** @internal */
export const GetApiV3MetricsAverageCycleBurnRateRequest$outboundSchema:
  z.ZodType<
    GetApiV3MetricsAverageCycleBurnRateRequest$Outbound,
    z.ZodTypeDef,
    GetApiV3MetricsAverageCycleBurnRateRequest
  > = z.object({
    format: GetApiV3MetricsAverageCycleBurnRateFormat$outboundSchema.default(
      "json",
    ),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsAverageCycleBurnRateRequest$ {
  /** @deprecated use `GetApiV3MetricsAverageCycleBurnRateRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3MetricsAverageCycleBurnRateRequest$inboundSchema;
  /** @deprecated use `GetApiV3MetricsAverageCycleBurnRateRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3MetricsAverageCycleBurnRateRequest$outboundSchema;
  /** @deprecated use `GetApiV3MetricsAverageCycleBurnRateRequest$Outbound` instead. */
  export type Outbound = GetApiV3MetricsAverageCycleBurnRateRequest$Outbound;
}

export function getApiV3MetricsAverageCycleBurnRateRequestToJSON(
  getApiV3MetricsAverageCycleBurnRateRequest:
    GetApiV3MetricsAverageCycleBurnRateRequest,
): string {
  return JSON.stringify(
    GetApiV3MetricsAverageCycleBurnRateRequest$outboundSchema.parse(
      getApiV3MetricsAverageCycleBurnRateRequest,
    ),
  );
}

export function getApiV3MetricsAverageCycleBurnRateRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiV3MetricsAverageCycleBurnRateRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3MetricsAverageCycleBurnRateRequest$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'GetApiV3MetricsAverageCycleBurnRateRequest' from JSON`,
  );
}

/** @internal */
export const AverageCycleBurnRate$inboundSchema: z.ZodType<
  AverageCycleBurnRate,
  z.ZodTypeDef,
  unknown
> = z.union([z.number().int(), z.string()]);

/** @internal */
export type AverageCycleBurnRate$Outbound = number | string;

/** @internal */
export const AverageCycleBurnRate$outboundSchema: z.ZodType<
  AverageCycleBurnRate$Outbound,
  z.ZodTypeDef,
  AverageCycleBurnRate
> = z.union([z.number().int(), z.string()]);

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace AverageCycleBurnRate$ {
  /** @deprecated use `AverageCycleBurnRate$inboundSchema` instead. */
  export const inboundSchema = AverageCycleBurnRate$inboundSchema;
  /** @deprecated use `AverageCycleBurnRate$outboundSchema` instead. */
  export const outboundSchema = AverageCycleBurnRate$outboundSchema;
  /** @deprecated use `AverageCycleBurnRate$Outbound` instead. */
  export type Outbound = AverageCycleBurnRate$Outbound;
}

export function averageCycleBurnRateToJSON(
  averageCycleBurnRate: AverageCycleBurnRate,
): string {
  return JSON.stringify(
    AverageCycleBurnRate$outboundSchema.parse(averageCycleBurnRate),
  );
}

export function averageCycleBurnRateFromJSON(
  jsonString: string,
): SafeParseResult<AverageCycleBurnRate, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AverageCycleBurnRate$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AverageCycleBurnRate' from JSON`,
  );
}

/** @internal */
export const GetApiV3MetricsAverageCycleBurnRateResponseBody$inboundSchema:
  z.ZodType<
    GetApiV3MetricsAverageCycleBurnRateResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    average_cycle_burn_rate: z.array(z.union([z.number().int(), z.string()]))
      .optional(),
  }).transform((v) => {
    return remap$(v, {
      "average_cycle_burn_rate": "averageCycleBurnRate",
    });
  });

/** @internal */
export type GetApiV3MetricsAverageCycleBurnRateResponseBody$Outbound = {
  average_cycle_burn_rate?: Array<number | string> | undefined;
};

/** @internal */
export const GetApiV3MetricsAverageCycleBurnRateResponseBody$outboundSchema:
  z.ZodType<
    GetApiV3MetricsAverageCycleBurnRateResponseBody$Outbound,
    z.ZodTypeDef,
    GetApiV3MetricsAverageCycleBurnRateResponseBody
  > = z.object({
    averageCycleBurnRate: z.array(z.union([z.number().int(), z.string()]))
      .optional(),
  }).transform((v) => {
    return remap$(v, {
      averageCycleBurnRate: "average_cycle_burn_rate",
    });
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsAverageCycleBurnRateResponseBody$ {
  /** @deprecated use `GetApiV3MetricsAverageCycleBurnRateResponseBody$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3MetricsAverageCycleBurnRateResponseBody$inboundSchema;
  /** @deprecated use `GetApiV3MetricsAverageCycleBurnRateResponseBody$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3MetricsAverageCycleBurnRateResponseBody$outboundSchema;
  /** @deprecated use `GetApiV3MetricsAverageCycleBurnRateResponseBody$Outbound` instead. */
  export type Outbound =
    GetApiV3MetricsAverageCycleBurnRateResponseBody$Outbound;
}

export function getApiV3MetricsAverageCycleBurnRateResponseBodyToJSON(
  getApiV3MetricsAverageCycleBurnRateResponseBody:
    GetApiV3MetricsAverageCycleBurnRateResponseBody,
): string {
  return JSON.stringify(
    GetApiV3MetricsAverageCycleBurnRateResponseBody$outboundSchema.parse(
      getApiV3MetricsAverageCycleBurnRateResponseBody,
    ),
  );
}

export function getApiV3MetricsAverageCycleBurnRateResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiV3MetricsAverageCycleBurnRateResponseBody,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3MetricsAverageCycleBurnRateResponseBody$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'GetApiV3MetricsAverageCycleBurnRateResponseBody' from JSON`,
  );
}

/** @internal */
export const GetApiV3MetricsAverageCycleBurnRateResponse$inboundSchema:
  z.ZodType<
    GetApiV3MetricsAverageCycleBurnRateResponse,
    z.ZodTypeDef,
    unknown
  > = z.union([
    models.ErrorT$inboundSchema,
    z.lazy(() => GetApiV3MetricsAverageCycleBurnRateResponseBody$inboundSchema),
  ]);

/** @internal */
export type GetApiV3MetricsAverageCycleBurnRateResponse$Outbound =
  | models.ErrorT$Outbound
  | GetApiV3MetricsAverageCycleBurnRateResponseBody$Outbound;

/** @internal */
export const GetApiV3MetricsAverageCycleBurnRateResponse$outboundSchema:
  z.ZodType<
    GetApiV3MetricsAverageCycleBurnRateResponse$Outbound,
    z.ZodTypeDef,
    GetApiV3MetricsAverageCycleBurnRateResponse
  > = z.union([
    models.ErrorT$outboundSchema,
    z.lazy(() =>
      GetApiV3MetricsAverageCycleBurnRateResponseBody$outboundSchema
    ),
  ]);

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsAverageCycleBurnRateResponse$ {
  /** @deprecated use `GetApiV3MetricsAverageCycleBurnRateResponse$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3MetricsAverageCycleBurnRateResponse$inboundSchema;
  /** @deprecated use `GetApiV3MetricsAverageCycleBurnRateResponse$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3MetricsAverageCycleBurnRateResponse$outboundSchema;
  /** @deprecated use `GetApiV3MetricsAverageCycleBurnRateResponse$Outbound` instead. */
  export type Outbound = GetApiV3MetricsAverageCycleBurnRateResponse$Outbound;
}

export function getApiV3MetricsAverageCycleBurnRateResponseToJSON(
  getApiV3MetricsAverageCycleBurnRateResponse:
    GetApiV3MetricsAverageCycleBurnRateResponse,
): string {
  return JSON.stringify(
    GetApiV3MetricsAverageCycleBurnRateResponse$outboundSchema.parse(
      getApiV3MetricsAverageCycleBurnRateResponse,
    ),
  );
}

export function getApiV3MetricsAverageCycleBurnRateResponseFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiV3MetricsAverageCycleBurnRateResponse,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3MetricsAverageCycleBurnRateResponse$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'GetApiV3MetricsAverageCycleBurnRateResponse' from JSON`,
  );
}
